class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
  }

  connectedCallback() {
    this.addEventListener('change', this.onOptionChange.bind(this));
  }

  onOptionChange(event) {
    const target = event.target;

    if (!target.closest('variant-selects')) return;

    const productUrl = this.dataset.url;
    const optionValues = this.getSelectedOptions();

    this.fetchAndRender(productUrl, optionValues);
  }

  getSelectedOptions() {
    const variantSelects = this.querySelector('variant-selects');
    if (!variantSelects) return [];

    // Dropdown version
    const selects = variantSelects.querySelectorAll('select');
    if (selects.length) {
      return Array.from(selects)
        .map((select) => {
          const selectedOption = select.selectedOptions[0];
          return selectedOption?.dataset.optionValueId;
        })
        .filter(Boolean);
    }

    // Button (radio) version
    const checkedRadios = variantSelects.querySelectorAll(
      'input[type="radio"]:checked'
    );

    return Array.from(checkedRadios)
      .map((radio) => radio.dataset.optionValueId)
      .filter(Boolean);
  }

  fetchAndRender(url, optionValues) {
    const params = new URLSearchParams();
    params.set('section_id', this.dataset.section);

    if (optionValues.length) {
      params.set('option_values', optionValues.join(','));
    }

    const requestUrl = `${url}?${params.toString()}`;

    this.abortController?.abort();
    this.abortController = new AbortController();


    fetch(requestUrl, { signal: this.abortController.signal })
    .then((res) => res.text())
    .then((htmlText) => {
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const newProductInfo = html.querySelector('product-info');

      if (!newProductInfo) return;

      const variant = this.getSelectedVariant(newProductInfo);

      this.innerHTML = newProductInfo.innerHTML;

      if (variant?.id) {
        window.history.replaceState({}, '', `${url}?variant=${variant.id}`);
      }
    })
    .catch((err) => {
      if (err.name !== 'AbortError') {
        console.error(err);
      }
    });
  }

  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode
      .querySelector('variant-selects [data-selected-variant]')
      ?.innerHTML;

    return selectedVariant ? JSON.parse(selectedVariant) : null;
  }
}

if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo);
}